w
<template>
  <article class="layout-section -align-side -reverse">
    <figure class="layout-section__figure -reverse" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.steps.title }}</h2>

      <article class="layout-steps">
        <section class="layout-steps__item">
          <div class="layout-steps__number">1</div>
          <div class="layout-steps__content">
            <h3 class="layout-steps__title">Téléchargez le formulaire</h3>
            <p>
              Commencez par télécharger le
              <a :href="wp.steps.registrationForm" target="_blank" class="layout-steps__link">formulaire d’adhésion</a>
              .
            </p>
          </div>
        </section>

        <section class="layout-steps__item">
          <div class="layout-steps__number">2</div>
          <div class="layout-steps__content">
            <h3 class="layout-steps__title">Remplissez et envoyez</h3>
            <p>
              Remplissez-le avec soin, puis envoyez-le à
              <a :href="`mailto:${wp.steps.registrationEmail}`" class="layout-steps__link">
                {{ wp.steps.registrationEmail }}
              </a>
              .
            </p>
          </div>
        </section>

        <section class="layout-steps__item">
          <div class="layout-steps__number">3</div>
          <div class="layout-steps__content">
            <h3 class="layout-steps__title">{{ wp.steps.finalStepTitle }}</h3>
            <p>
              {{ wp.steps.finalStepText }}
            </p>
          </div>
        </section>
      </article>
    </section>
  </article>
</template>

<script>
export default {
  name: 'RegisterHow',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.steps.image})`
    }
  }
}
</script>
